import { render, staticRenderFns } from "./couponItemV2.vue?vue&type=template&id=644b0f9a&scoped=true&"
import script from "./couponItemV2.vue?vue&type=script&lang=js&"
export * from "./couponItemV2.vue?vue&type=script&lang=js&"
import style0 from "./couponItemV2.vue?vue&type=style&index=0&id=644b0f9a&scoped=true&lang=scss&"
import style1 from "./couponItemV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b0f9a",
  null
  
)

export default component.exports